<template>
    <div class="contacts-supply-chains">
        <div class="contacts-supply-staff">
            <div v-for="(staff, index) in staffArray" :key="index" class="staff-profile" @click="selectProfile(staff)">
                <div class="staff-avatar-back2"></div>
                <div v-if="staff.img" class="staff-avatar" :style="{backgroundImage: 'url(' + staff.img + ')'}"></div>
                <span v-if="!staff.img" class="staff-avatarless">
                    <span class="alcomet">a</span>
                </span>
                <h3>{{staff.name}}</h3>
                <h4>{{staff.position}}</h4>
            </div>
        </div>
        <app-profile-modal v-if="selectedProfile" :staffProfile="selectedProfile"></app-profile-modal>
    </div>
</template>

<script>
import Staff from "./SupplyChains.json";
import ProfileModal from "./ProfileModal";
export default {
  components: {
    appProfileModal: ProfileModal
  },
  data() {
    return {
      staffArray: Staff,
      selectedProfile: undefined
    };
  },
  methods: {
    selectProfile(profile) {
      this.selectedProfile = profile;
      // add the custom profile url to the main url
      this.$router.replace({
        name: "ContactsProfile",
        params: { page: "supply-chains", profile: profile.url }
      });
    }
  },
  mounted() {
    // find profile if params profile
    if (this.$route.params.profile) {
      this.selectedProfile = this.staffArray.filter(s => {
        return s.url === this.$route.params.profile;
      })[0];
    }
    // listen for the 'close-profile' event from ProfileModal.vue
    this.$eventHub.$on("close-profile", () => {
      this.selectedProfile = undefined;
      this.$router.replace({
        name: "Contacts",
        params: { page: "supply-chains" }
      });
    });
  },
  destroyed() {
    this.$eventHub.$off("close-profile");
  }
};
</script>

<style scoped>
.contacts-supply-chains {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 40px 40px 0;
}
.contacts-supply-staff {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 1000px;
}
.staff-profile {
  align-items: center;
  cursor: pointer;
  display: flex;
  padding-top: 220px;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 280px;
}
.staff-avatar,
.staff-avatar-back2,
.staff-avatarless {
  background-size: cover;
  background-position: center;
  border: 5px solid #dcebf4;
  border-radius: 50%;
  left: calc(50% - 110px);
  position: absolute;
  top: 0;
  height: 220px;
  width: 220px;
}
.staff-avatarless {
  align-items: center;
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.staff-avatarless span {
  font-size: 100px;
}
.staff-avatar {
  -webkit-transition: transform 3s cubic-bezier(0.075, 0.82, 0.165, 1);
  -moz-transition: transform 3s cubic-bezier(0.075, 0.82, 0.165, 1);
  -ms-transition: transform 3s cubic-bezier(0.075, 0.82, 0.165, 1);
  -o-transition: transform 3s cubic-bezier(0.075, 0.82, 0.165, 1);
  transition: transform 3s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.staff-avatar-back2 {
  background-color: #dcebf4;
  border: 0;
  height: 220px;
  opacity: 0.2;
  -webkit-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  -moz-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  -ms-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  -o-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  width: 220px;
}

.staff-profile:hover .staff-avatar {
  transform: scale(1.03);
}

.staff-profile:hover .staff-avatar-back2 {
  height: 240px;
  left: 20px;
  top: -10px;
  width: 240px;
}

.staff-profile h3 {
  font-size: 24px;
  text-align: center;
  margin: 10px 0;
}
.staff-profile h4 {
  font-size: 13px;
  height: 120px;
  text-transform: uppercase;
  text-align: center;
  width: 220px;
}

@media screen and (max-width: 1700px) {
}
@media screen and (max-width: 1280px) {
  .contacts-supply-staff {
    width: 100%;
  }
}
@media screen and (max-width: 1000px) {
  .contacts-supply-chains {
    padding: 50px 0 0;
  }
  .contacts-supply-staff {
    width: 100%;
  }
  .staff-profile h3 {
    font-size: 20px;
    margin: 10px 0 5px;
  }
  .staff-profile h4 {
    font-size: 12px;
  }
}
@media screen and (max-width: 600px) {
  .staff-profile {
    align-items: flex-start;
    margin: 10px 0;
    min-height: 80px;
    padding: 0 30px 0 130px;
    width: 100%;
  }
  .staff-avatar,
  .staff-avatarless {
    border: 2px solid #dcebf4;
    height: 80px;
    left: 30px;
    width: 80px;
  }
  .staff-avatar-back2 {
    display: none;
  }
  .staff-avatarless span {
    font-size: 30px;
  }
  .staff-profile h3 {
    margin-top: 0;
    text-align: left;
    width: 100%;
  }
  .staff-profile h4 {
    height: initial;
    text-align: left;
    width: 100%;
  }
}
@media screen and (max-width: 380px) {
  .staff-profile h3 {
    font-size: 16px;
  }
  .staff-profile h4 {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/SupplyChains.vue